export const DEFAULT_LABEL = "TiVo Apps";
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const DEFUALT_INPUT_PLACEHOLDER = "Pick an tivo app...";
